/**
 * Parses a masked numeric string to a number by removing formatting characters like commas.
 * Returns 0 if the value is null, undefined, or empty.
 *
 * @param value The masked string value (e.g., "1,400.00").
 * @returns The parsed numeric value (e.g., 1400).
 */
export function parseMaskedStringToNumber(
    value: string | null | undefined,
): number {
    if (!value) {
        return 0;
    }

    return parseFloat(value.replace(/,/g, ''));
}
